const mediaItems = [
  {
    title: '热映大片《星际征途》高清完整版',
    tag: '动作科幻',
    duration: '128分钟',
    views: '89.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20thumbnail%20with%20dramatic%20lighting%2C%20movie%20scene%20aesthetic%2C%20dark%20background%20with%20warm%20golden%20accents%2C%20professional%20film%20photography%2C%20rich%20contrast%20and%20deep%20shadows%2C%20cinematic%20color%20grading&width=640&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '热门剧集《长安风云》第38集更新',
    tag: '古装权谋',
    duration: '45分钟',
    views: '156.7万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20film%20poster%20with%20traditional%20costumes%20and%20ornate%20architecture%2C%20dramatic%20warm%20lighting%2C%20golden%20and%20red%20tones%2C%20cinematic%20photography%2C%20rich%20textures%20and%20atmospheric%20mood&width=640&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '综艺《欢乐集结号》最新一期上线',
    tag: '搞笑综艺',
    duration: '90分钟',
    views: '203.4万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20studio%20lights%2C%20entertainment%20show%20atmosphere%2C%20vibrant%20colors%20on%20dark%20background%2C%20professional%20TV%20production%20photography%2C%20lively%20and%20energetic%20composition&width=640&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '高分纪录片《蓝色星球·深海之谜》',
    tag: '自然纪录',
    duration: '52分钟',
    views: '67.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20bioluminescent%20creatures%2C%20dark%20blue%20water%20with%20rays%20of%20light%2C%20documentary%20film%20aesthetic%2C%20mysterious%20deep%20sea%20atmosphere%2C%20cinematic%20nature%20photography%20with%20dramatic%20contrast&width=640&height=400&seq=media-04&orientation=landscape',
  },
  {
    title: '热门动漫《灵笼·终章》全集放送',
    tag: '科幻动漫',
    duration: '24集全',
    views: '112.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20anime%20style%20illustration%20with%20mecha%20and%20cyberpunk%20city%2C%20dramatic%20lighting%20with%20orange%20and%20dark%20tones%2C%20dynamic%20composition%2C%20professional%20animation%20art%20style%2C%20rich%20detail%20and%20atmospheric%20mood&width=640&height=400&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <span className="text-xs text-accent-400 whitespace-nowrap">精选推荐</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">热门影视精选</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            精选西瓜视频免费与91在线视频热门内容，高清流畅不卡顿
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item) => (
            <div key={item.views} className="group bg-background-200/60 rounded-xl overflow-hidden hover:bg-background-200 transition-colors cursor-pointer">
              <div className="relative aspect-[16/10] bg-background-300 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded bg-primary-500/90 text-xs text-background-50 whitespace-nowrap">
                  {item.tag}
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-xs text-foreground-200 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-200 line-clamp-2 leading-snug mb-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  <span className="whitespace-nowrap">{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}